export default  {
    tipoCobertura: {
        COMPREENSIVA: 1,
        INCENDIO_ROUBO: 2,
        RCF: 3, 
        COMPRESSIVA_RCF:4
    }
}


// WEBPACK FOOTER //
// ./src/helpers/tipo-cobertura-enum.js